import React from 'react';

const InvisibleOverlay = ({ children, onClick }) => (
  <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, top: 0, zIndex: 10 }} onClick={onClick}>
    {children}
  </div>
);

export default InvisibleOverlay;
